import styled from 'styled-components';

const PortfolioPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);

    .imgs-container {
        display: flex;
        flex-wrap: wrap;
        margin-top: 60px;
        img {
            cursor: pointer;
        }
    }
    .more {
        background-color: var(--main-color);
        color: white;
        padding: 15px 20px;
        display: block;
        width: fit-content;
        margin: 30px auto;
        text-decoration: none;
        text-transform: uppercase;
    }
`;

export default PortfolioPageContainer;
